export enum OrderStatus {
  DRAFT = "DRAFT",
  RECEIVED = "RECEIVED",
  CONFIRMED = "CONFIRMED",
  SHIPMENT_STARTED = "SHIPMENT_STARTED",
  SHIPMENT_COMPLETED = "SHIPMENT_COMPLETED",
  CANCELLED = "CANCELLED",
  TAX_PROCESSED = "TAX_PROCESSED",
}

export const OrderStatusDisplayNames = {
  [OrderStatus.DRAFT]: "발주 대기",
  [OrderStatus.RECEIVED]: "발주 접수",
  [OrderStatus.CONFIRMED]: "발주 확인",
  [OrderStatus.SHIPMENT_STARTED]: "배송 시작",
  [OrderStatus.SHIPMENT_COMPLETED]: "배송 완료",
  [OrderStatus.CANCELLED]: "발주 취소",
  [OrderStatus.TAX_PROCESSED]: "발주 완료",
};
